import { useEventBus } from '@vueuse/core'

/**
 * Класс для работы с событиями AuthSDK
 * 
 * @example
 * AuthSDKEvents.auth.on(() => {
 *   
 * })
 */
export class AuthSDKEvents {
  public static readonly auth = useEventBus('authSDK.auth')
  public static readonly logout = useEventBus('authSDK.logout')
}